import React, { useReducer, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { AsyncModel, AsyncModelClose } from '../AsyncModel/AsyncModel';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CusButton } from '../../Components/From/Button';
import { CusInput } from '../../Components/From/Input';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Global } from '../../App';
import ReactLoading from 'react-loading';
import QRCode from 'qrcode.react';
import '../../Pages/pages.scss';
// api
import { getSendEmail } from '../../Api/VerifyQueue';
import { useMemo } from 'react';
import moment from 'moment';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function OrderStep_5(props) {
  AsyncModelClose();
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    orderCode: globalState.customer.orderInfo.orderCode
  });

  let pcStyle = globalState.device === 'pc';

  const hostname = useMemo(() => {
    return `${window.location.protocol}//${window.location.host}${window.env.BASENAME}`
  }, [])

  console.log(state)
  return (
    <div className="d-flex justify-content-center">
      <div
        style={{
          minWidth: pcStyle ? '450px' : '100%',
          maxWidth: pcStyle ? '450px' : '100%'
        }}
      >
        <p className="text-center mt-4">
          <FormattedHTMLMessage id="pages.takeOrder.step5.finishNote" />
        </p>
        <p className="text-center mb-4 txtColorRed">
          <FormattedHTMLMessage id="pages.takeOrder.step5.orderNotice" />
        </p>
        <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
          <QRCode value={`${hostname}/staffCheckOrder?orderCode=${state.orderCode}&storeID=${String(globalState.customer.orderInfo.selectedBranch.branchCode)}&createAt=${moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD')}`} size={160} renderAs="svg" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
          <CusInput
            className="w-100"
            onChange={() => { }}
            readonly
            label={<FormattedMessage id="pages.takeOrder.step5.orderCode" />}
            value={state.orderCode}
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          {/* 可使用 Web Share API */}
          {navigator.share ? (
            <CusButton.White
              className="col mb-4 p-3 order-step5-copy"
              children={
                <FormattedMessage id="pages.takeOrder.step5.buttonShare" />
              }
              onClick={async () => {
                // 當使用者點擊分享時要帶入的資訊
                const shareData = {
                  title: `${globalState.langFile['pages.takeOrder.share.title']} ${state.orderCode}`, // 要分享的標題
                  text: `${globalState.langFile['pages.takeOrder.share.content']}\n${globalState.customer.orderInfo.selectedBranch.branchName || ''} ${globalState.customer.orderInfo.queueNumber ? `${globalState.langFile['pages.takeOrder.share.queueNumber']} ${globalState.customer.orderInfo.queueNumber}` : ''}\n${hostname}/showOrderDetail?orderCode=${state.orderCode}&storeID=${String(globalState.customer.orderInfo.selectedBranch.branchCode)}&createAt=${moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD')}\n${globalState.langFile['pages.takeOrder.share.note']}` // 要分享的文字內容
                };
                try {
                  // 使用 Web Share API
                  await navigator.share(shareData);
                  // 分享成功
                  console.log('share success');
                } catch (err) {
                  // 使用者拒絕分享或發生錯誤
                  const { name, message } = err;
                  if (name === 'AbortError') {
                    console.log('cancel share', err);
                  } else {
                    console.log('share error', err);
                  }
                }
              }}
            />
          ) : (
            <CopyToClipboard text={`${hostname}/showOrderDetail?orderCode=${state.orderCode}&storeID=${String(globalState.customer.orderInfo.selectedBranch.branchCode)}&createAt=${moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD')}`}>
              <CusButton.White
                className="col mb-4 p-3 order-step5-copy"
                children={
                  <FormattedMessage id="pages.takeOrder.step5.buttonCopy" />
                }
                onClick={async () => {
                  const alert = await AsyncModel({
                    title: globalState.langFile['popup.msgCopyToClipboard'],
                    confirmBtnText: globalState.langFile['popup.buttonConfirm']
                  });
                }}
              />
            </CopyToClipboard>
          )}
          <CusButton.White
            className="col mb-4 p-3 order-step5-verify"
            children={
              <FormattedMessage id="pages.takeOrder.step5.buttonDetail" />
            }
            onClick={async () => {
              window.open(`/showOrderDetail?orderCode=${state.orderCode}&storeID=${String(globalState.customer.orderInfo.selectedBranch.branchCode)}&createAt=${(globalState.customer.orderInfo.orderTime) ? moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD'):moment().format('YYYY/MM/DD')}`)
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(OrderStep_5);
